import { useState } from 'react';
import invokeLambda from 'utils/lambda';
import { AWSCognitoToken, AWSConfig } from 'config/AWSConfig';
import axios from 'axios';
import { Config, IISMethods } from 'config/IISMethods';
import useService from './useService';

const useCognito = () => {
    const { getStorageData } = useService()
    const [userPoolId] = useState(AWSConfig.AuthData.UserPoolId);
    const [identityPoolId] = useState(AWSConfig.AuthData.IdentityPollId);

    const API_Call = async (m = 'g', url, payload = {}, headers = {}, options = {}) => {
        const Controller = new AbortController();
        const signal = Controller.signal;

        let method = { 'p': 'POST', 'd': 'DELETE', 'u': 'PUT', 'g': 'GET' }[m] || 'GET';

        let ReqBody = payload, ResponseBody, ResponseHeaders, Response;
        let ReqHeaders = { ...headers };

        try {
            if (getStorageData('digitalkeydata')?.subdomainname) {
                ReqHeaders.subdomainname = getStorageData('digitalkeydata')?.subdomainname
            }
            ReqHeaders.moduletype = 'digitalkey'
            ReqHeaders.pagename = 'digitalkey'
            // if (Config.getServermode() !== 'dev') {
            //     reqHeaders.Authorization = AWSCognitoToken;
            // }

            if (Config.encryptdata) { ReqHeaders = { reqheader: IISMethods.encryptData(ReqHeaders) } }
            let index = -1
            try { index = ReqBody?.indexOf('.') }
            catch { index = -1 }

            if (Config.ACCESS_KEY) ReqHeaders['accesskey'] = Config.ACCESS_KEY
            if (Config.encryptdata && index == -1) {
                if (!ReqBody.reqBody) { ReqBody = { reqBody: IISMethods.encryptData(ReqBody) } }
            }

            // let result = { status: 200, data: { Result: { status: 200, data: { Result: 'test' } } }, headers: { resheader: 'test' } }// await axios({ url, method, headers: reqHeaders, data: reqBody })
            let result = await axios({ url, method, headers: ReqHeaders, data: ReqBody, signal: signal, ...options })

            if (Config.encryptdata) {
                try { ResponseBody = JSON.parse(IISMethods.decryptData(result.data)) }
                catch { ResponseBody = result.data }

                if (result.headers?.resheader) { ResponseHeaders = JSON.parse(IISMethods.decryptData(result.headers?.resheader)) }
                else { ResponseHeaders = result.headers }
            }
            else {
                ResponseBody = result.data
                ResponseHeaders = result.headers
            }
            Response = { Result: ResponseBody, Controller, ResponseHeaders };
        }
        catch (error) {
            if (error.code === 'ECONNABORTED') { // For request Timeout
                Response = { Result: { status: 408, title: Config.ErrorMessages['requesttimeout'].title, message: error.message }, ResponseHeaders: {} }
            }
            else if (['ERR_NETWORK'].includes(error.code)) { // For Network Error
                Response = { Result: { status: 502, ...Config.ErrorMessages['networkerror'] }, ResponseHeaders: {} }
            }
            else {
                if (Config.encryptdata) {
                    try { ResponseBody = JSON.parse(IISMethods.decryptData(error.response.data)) }
                    catch { ResponseBody = error.response.data }

                    if (error.response?.headers?.resheader) { ResponseHeaders = JSON.parse(IISMethods.decryptData(error.response?.headers?.resheader)) }
                    else { ResponseHeaders = error.response.headers }
                }
                else {
                    ResponseBody = error.response?.data
                    ResponseHeaders = error.response?.headers
                }
                Response = { Result: ResponseBody, Controller, ResponseHeaders }
            }
        }
        finally {
            if (['dev', 'uat', 'prod'].includes(Config.getServermode())) console.log("🌟✨ BR >  ~ API_Call ~ Response:", { ...Response, ReqBody, ReqHeaders, ReqBody })
            return Response
        }
    }

    const InvokeLambda = (functionName, payload = {}) => {
        return new Promise((resolve, reject) => {

            let reqBody = payload;

            let index = -1
            try { index = reqBody?.indexOf('.') }
            catch { index = -1 }

            if (Config.encryptdata && index == -1) {
                if (!reqBody.reqBody) { reqBody = { reqBody: IISMethods.encryptData(reqBody) } }
            }

            if (!AWSCognitoToken) {
                console.error('Authentication failed.');
                reject('Authentication failed.');
            }

            let resBody, resHeaders;

            invokeLambda(
                AWSCognitoToken,
                userPoolId,
                identityPoolId,
                functionName,
                reqBody,
                (error, result) => {
                    if (error) {
                        if (Config.encryptdata) {
                            try { resBody = JSON.parse(JSON.parse(IISMethods.decryptData(error.response.data))) }
                            catch { resBody = error.response.data }

                            if (error.response.headers.resheader) { resHeaders = JSON.parse(JSON.parse(IISMethods.decryptData(error.response?.headers?.resheader))) }
                            else { resHeaders = error.response.headers }
                        }
                        else {
                            resBody = error.response.data
                            resHeaders = error.response.headers
                        }
                        console.error('Lambda error:', error);
                        resolve(Object.assign({ resBody, resHeaders }));
                    }
                    else {
                        if (Config.encryptdata) {
                            try { resBody = JSON.parse(JSON.parse(IISMethods.decryptData(result))) }
                            catch { resBody = result }

                            if (result.headers.resheader) { resHeaders = JSON.parse(JSON.parse(IISMethods.decryptData(result?.headers?.resheader))) }
                            else { resHeaders = result.headers }
                        }
                        else {
                            resBody = result.data
                            resHeaders = result.headers
                        }
                        console.log('Lambda result:', result);
                        resolve(Object.assign({ resBody, resHeaders }));
                    }
                }
            );
        })
    };

    return { InvokeLambda, API_Call };
};

export default useCognito;
